// Function to scroll to and click an element based on hash
function scrollToAndOpenElement() {
  // Check if there's a hash in the URL
  const hash = window.location.hash;
  // Only proceed if a hash is present
  if (hash) {
    // Remove the '#' character to get the ID
    const elementId = hash.substring(1);
    // Find the element with the corresponding ID
    const targetElement = document.getElementById(elementId);
    // If the element exists, scroll to it and open it
    if (targetElement) {
      // Scroll to the element smoothly
      targetElement.scrollIntoView({ behavior: 'smooth' });
      // Open element
      var details = targetElement.querySelector('details');
      var summary = targetElement.querySelector('summary');
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    }
  }
}
// Call the function on page load
window.onload = scrollToAndOpenElement;
// Call the function when the hash changes
window.onhashchange = scrollToAndOpenElement;